// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.FormField_formField__iLxd1 {
  margin-bottom: 1rem;
  width: 100%;
}

.FormField_label__Dn7Iy {
  font-weight: 500;
  color: var(--black);
  margin-bottom: 0.5rem;
  display: block;
  font-size: 0.95rem;
}

.FormField_required__F2OlX {
  color: var(--red);
  margin-left: 0.25rem;
  font-weight: 600;
}

.FormField_input__5TMnt {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0.4rem 0.8rem;
  font-size: 1rem;
  transition: all 0.2s ease;
  width: 100%;
}
.FormField_input__5TMnt:focus {
  outline: none;
  border-color: var(--orange);
  box-shadow: 0 0 0 2px rgba(243, 156, 18, 0.1);
}
.FormField_input__5TMnt:hover:not(:disabled) {
  border-color: #bbb;
}

.FormField_inputError__jRQvT {
  border-color: var(--red) !important;
}
.FormField_inputError__jRQvT:focus {
  border-color: var(--red) !important;
  box-shadow: 0 0 0 2px rgba(221, 75, 57, 0.1) !important;
}

.FormField_inputDisabled__S8OQE {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}
.FormField_inputDisabled__S8OQE:hover {
  border-color: #ddd;
}

.FormField_errorMessage__Xa0KA {
  color: var(--red);
  font-size: 0.875rem;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}
.FormField_errorMessage__Xa0KA::before {
  content: "⚠️";
  margin-right: 0.5rem;
}

.FormField_infoWrapper__UU4YI {
  position: relative;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.FormField_infoWrapper__UU4YI:hover .FormField_tooltipText__bS9X2 {
  visibility: visible;
  opacity: 1;
}

.FormField_infoIcon__MxExS {
  color: #888;
}

.FormField_tooltipText__bS9X2 {
  visibility: hidden;
  width: max-content;
  max-width: 200px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 50;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 12px;
}
.FormField_tooltipText__bS9X2::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/FormField/FormField.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAEF;;AACA;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AAEF;AAAE;EACE,aAAA;EACA,2BAAA;EACA,6CAAA;AAEJ;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,mCAAA;AAAF;AAEE;EACE,mCAAA;EACA,uDAAA;AAAJ;;AAIA;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AADF;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;EACA,oBAAA;AAFJ;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAFF;AAIE;EACE,mBAAA;EACA,UAAA;AAFJ;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;AAHF;AAKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;AAHJ","sourcesContent":[".formField {\r\n  margin-bottom: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.label {\r\n  font-weight: 500;\r\n  color: var(--black);\r\n  margin-bottom: 0.5rem;\r\n  display: block;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.required {\r\n  color: var(--red);\r\n  margin-left: 0.25rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.input {\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  padding: 0.4rem 0.8rem;\r\n  font-size: 1rem;\r\n  transition: all 0.2s ease;\r\n  width: 100%;\r\n\r\n  &:focus {\r\n    outline: none;\r\n    border-color: var(--orange);\r\n    box-shadow: 0 0 0 2px rgba(243, 156, 18, 0.1);\r\n  }\r\n\r\n  &:hover:not(:disabled) {\r\n    border-color: #bbb;\r\n  }\r\n}\r\n\r\n.inputError {\r\n  border-color: var(--red) !important;\r\n  \r\n  &:focus {\r\n    border-color: var(--red) !important;\r\n    box-shadow: 0 0 0 2px rgba(221, 75, 57, 0.1) !important;\r\n  }\r\n}\r\n\r\n.inputDisabled {\r\n  background-color: #f8f9fa;\r\n  color: #6c757d;\r\n  cursor: not-allowed;\r\n  \r\n  &:hover {\r\n    border-color: #ddd;\r\n  }\r\n}\r\n\r\n.errorMessage {\r\n  color: var(--red);\r\n  font-size: 0.875rem;\r\n  margin-top: 0.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  \r\n  &::before {\r\n    content: '⚠️';\r\n    margin-right: 0.5rem;\r\n  }\r\n}\r\n.infoWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-left: 5px;\r\n  cursor: pointer;\r\n\r\n  &:hover .tooltipText {\r\n    visibility: visible;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.infoIcon {\r\n  color: #888;\r\n}\r\n\r\n.tooltipText {\r\n  visibility: hidden;\r\n  width: max-content;\r\n  max-width: 200px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  position: absolute;\r\n  z-index: 50;\r\n  bottom: 120%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  opacity: 0;\r\n  transition: opacity 0.2s;\r\n  font-size: 12px;\r\n\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 100%; \r\n    left: 50%;\r\n    margin-left: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: #333 transparent transparent transparent;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formField": `FormField_formField__iLxd1`,
	"label": `FormField_label__Dn7Iy`,
	"required": `FormField_required__F2OlX`,
	"input": `FormField_input__5TMnt`,
	"inputError": `FormField_inputError__jRQvT`,
	"inputDisabled": `FormField_inputDisabled__S8OQE`,
	"errorMessage": `FormField_errorMessage__Xa0KA`,
	"infoWrapper": `FormField_infoWrapper__UU4YI`,
	"tooltipText": `FormField_tooltipText__bS9X2`,
	"infoIcon": `FormField_infoIcon__MxExS`
};
export default ___CSS_LOADER_EXPORT___;
